<ng-template #vendorStrategiesInfo>
  <div class="review-strategies upload-client h-100 d-flex flex-column">
    <div class="d-flex mb-3 flex-fill min-h-0">
      <div class="strategies-list d-flex flex-column">
        <div class="bold heading header-col">Selected Strategies</div>
        <div class="d-flex flex-column padding-10 flex-fill min-h-0 overflow-auto">
          <div class="pointer strategy-info-box d-flex flex-column mt-2 mb-2" [ngClass]="{'selected-strategy' : item.selected}" *ngFor="let item of strategies;let i = index" (click)="selectStrategy(item)">
            <div class="d-flex flex-column" style="width: 100%;">
              <div class="d-flex justify-content-between move-strategy">
                <div class="bold strategy-name mb-2">{{item.strategyName}}</div>
                <div *ngIf="item.reviewed">
                  <img style="width: 18px;height: 18px;" src="../../../images/core-focus/reviewed-success.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="strategy-info d-flex flex-column">
        <div class="d-flex header-col">
          <div class="bold heading">Upload Strategy Resources</div>
        </div>
        <div class="flex-fill min-h-0 overflow-auto">
          <div class="d-flex flex-column" *ngIf="strategies && strategies.length > 0">

            <div class="row">
              <div class="medium-12 columns mt-3">
                <div style="font-size: 14px;"><strong>{{currentSelectedStrategy.strategyName || ''}}</strong></div>
              </div>
              <div class="medium-12 columns mt-2">
                <label>Offer Description
                  <div style="border:1px solid #D0D5DD;border-radius: 3px;padding:10px;" [froalaEditor]="editorOptions" [(froalaModel)]="currentSelectedStrategy.description"></div>
                </label>
              </div>

              <div class="medium-12 columns mt-3 mb-3">
                <label>
                  Documents
                  <section class="upload-area create-post" ng2FileDrop [uploader]="fileUploader" (onFileDrop)="fileDropOver($event, 'file')" (fileOver)="fileOverBase($event, 'file')">
                    <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasFileBaseDropZoneOver}">
                      <div class="columns medium-12 text-center">
                  <span class="pointer">
                    <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                    <label for="vendorFilesUpload" class="button upload-section-content">Upload File(s)</label>
                  </span>
                        <input type="file" id="vendorFilesUpload" (change)="fileDropOver($event, 'file')" value="null" class="show-for-sr" ng2FileSelect [uploader]="fileUploader" multiple/>
                      </div>
                    </div>
                  </section>
                </label>
              </div>
              <div class="medium-12 columns row-margin" *ngIf="currentSelectedStrategy.files.length > 0">
                <div class="d-flex flex-wrap">
                  <div class="vendor-file-box d-flex justify-content-between mb-2"  *ngFor="let file of currentSelectedStrategy.files; let i=index;">
                    <div *ngIf="file.fileType === 'pdf'"><img src="../../../images/tpiq-icons/pdf-icon.png"/></div>
                    <div *ngIf="file.fileType === 'excel'"><img src="../../../images/tpiq-icons/excel-icon.png"/></div>
                    <div class="file-name">{{file.name}}</div>
                    <div class="pointer" (click)="deleteDocumentFile(file, i, 'file')">
                      <i class="icon ion-android-close"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="medium-12 columns mt-3 mb-3">
                <label>
                  Images
                  <section class="upload-area create-post" ng2FileDrop [uploader]="imageUploader" (onFileDrop)="fileDropOver($event, 'image')" (fileOver)="fileOverBase($event, 'image')">
                    <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasImageBaseDropZoneOver}">
                      <div class="columns medium-12 text-center">
                  <span class="pointer">
                    <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                    <label for="vendorImagesUpload" class="button upload-section-content">Upload Image(s)</label>
                  </span>
                        <input type="file" accept="image/*" id="vendorImagesUpload" (change)="fileDropOver($event, 'image')" value="null" class="show-for-sr" ng2FileSelect [uploader]="imageUploader" multiple/>
                      </div>
                    </div>
                  </section>
                </label>
              </div>
              <div class="medium-12 columns row-margin mb-2" *ngIf="currentSelectedStrategy.images.length > 0">
                <div class="d-flex flex-wrap">
                  <div class="d-flex vendor-file-box mb-2 flex-column" *ngFor="let image of currentSelectedStrategy.images; let index = index;">
                    <ng-template [ngIf]="image.name">
                      <div class="d-flex justify-content-between file-name-box">
                        <div class="file-name">{{image.name}}</div>
                        <div class="pointer" (click)="deleteDocumentFile(image, index, 'image')">
                          <i class="icon ion-android-close"></i>
                        </div>
                      </div>
                      <div class="mt-2" style="padding: 0px;margin-left: 0px" *ngIf="image.link">
                        <img class="image-zoom" [src]="image.link"/>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="medium-12 columns mt-3 mb-3">
                <label>
                  Videos
                  <section class="upload-area create-post" ng2FileDrop [uploader]="videoUploader" (onFileDrop)="fileDropOver($event, 'video')" (fileOver)="fileOverBase($event, 'video')">
                    <div class="row upload-choose-btn tpiq-upload-section" [ngClass]="{'popup-file-over': hasVideoBaseDropZoneOver}">
                      <div class="columns medium-12 text-center">
                  <span class="pointer">
                    <img src="../../../images/tpiq-icons/upload-cloud.png"/>
                    <label for="vendorVideoUpload" class="button upload-section-content">Upload Video(s)</label>
                  </span>
                        <input type="file" accept="video/*" id="vendorVideoUpload" (change)="fileDropOver($event, 'video')" value="null" class="show-for-sr" ng2FileSelect [uploader]="videoUploader" multiple/>
                      </div>
                    </div>
                  </section>
                </label>
              </div>
              <div class="medium-12 columns row-margin mb-2" *ngIf="currentSelectedStrategy.videos.length > 0">
                <div class="d-flex flex-wrap">
                  <div class="d-flex vendor-file-box mb-2 flex-column" *ngFor="let video of currentSelectedStrategy.videos; let index = index;">
                    <ng-template [ngIf]="video.name">
                      <div class="d-flex justify-content-between file-name-box">
                        <div class="file-name">{{video.name}}</div>
                        <div class="pointer" (click)="deleteDocumentFile(video, index, 'video')">
                          <i class="icon ion-android-close"></i>
                        </div>
                      </div>
                      <div *ngIf="video" class="text-center mt-2">
                        <video class="video-tag" style="margin: 0 auto;width: '100%'; height: 300px;" oncontextmenu="return false;" controlsList="nodownload" controls="" preload="auto" poster=""><source src="{{video.link}}" type="video/mp4"></video>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="medium-12 columns mt-3 mb-3">
                <div class="d-flex flex-column offer-section">
                  <div class="mb-2"><label>Offer Discount</label></div>
                  <div class="d-flex mt-2">
                    <input class="pointer" type="radio" name="strategy-offer" (click)="setStrategyOfferType('percentage')" [checked]="currentSelectedStrategy.offer.offerType == 'percentage'"> <label class="offer-type">By Percentage</label>
                    <input class="pointer" type="radio" style="margin-left: 15px;" name="strategy-offer" (click)="setStrategyOfferType('price')" [checked]="currentSelectedStrategy.offer.offerType == 'price'"> <label class="offer-type">By Price</label>
                  </div>
                  <div class="d-flex mb-2 offer-info">
                    <div class="d-flex pe-2 flex-column">
                      <ng-template [ngIf]="currentSelectedStrategy.offer.offerType == 'price'">
                        <div><label>Add Price</label></div>
                        <div>
                          <input type="text" placeholder="Price" [(ngModel)]="currentSelectedStrategy.offer.offerValue" model-numeral [format]="'$0,0.00'" [locale]="'usd'"/>
                        </div>
                      </ng-template>
                      <ng-template [ngIf]="currentSelectedStrategy.offer.offerType == 'percentage'">
                        <div><label>Add Percentage</label></div>
                        <div>
                          <input type="text" placeholder="Percentage" [(ngModel)]="currentSelectedStrategy.offer.offerValue"/>
                        </div>
                      </ng-template>
                    </div>
                    <div class="d-flex ps-2 offer-link">
                      <label>
                        Add Hubspot Form Link
                        <input type="text" [(ngModel)]="currentSelectedStrategy.offer.link" placeholder="Hubspot Form Link"/>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
